import React from 'react';

// Design System Components
import Checkbox from 'Components/DesignSystem/Checkbox/Checkbox';

// Constants
import { STRINGS } from '../../../constants';

interface StrikethroughSectionProps {
  /** Per element, like the UOM checkbox above it has also been since 14021. */
  strikethrough: boolean;
  onStrikethroughChange: (strikethrough: boolean) => void;
}

/**
 * The Strikethrough section: one checkbox, for the price fields (14021).
 *
 * It renders immediately below Pricing, which is where the design places it — but it
 * is a section of its own rather than a second checkbox inside `PricingSection`,
 * because `PricingSection` takes no field id — "there is nothing per-element to get
 * wrong here", its own docstring states (ADR-4C) — and this control is **per
 * element**: striking Sale Price must leave List Price alone. Folding it in would
 * break that invariant. (`showUom` was card-wide when this section was written, which
 * is what the split originally turned on; 14021 made it per element too, but the
 * invariant argument stands on its own.)
 *
 * It also lets `savingsPct` offer Strikethrough without declaring Pricing, which
 * would have shown a unit-of-measure checkbox on a percentage.
 *
 * Like every section here it knows nothing about which field it is inside — the
 * membership question is answered by `constants/PROPERTY_SECTIONS` (ADR-4B).
 */
const StrikethroughSection = ({
  strikethrough,
  onStrikethroughChange,
}: StrikethroughSectionProps) => (
  // No SectionHeading: the design renders this checkbox directly under the Pricing
  // section's own, with no heading of its own, so the two read as one group.
  <div className="tw-flex tw-flex-col tw-gap-2 tw-px-3 tw-py-3 tw-border-b tw-border-edge">
    <Checkbox
      label={STRINGS.pane.strikethrough}
      checked={strikethrough}
      onChange={onStrikethroughChange}
      size="sm"
    />
  </div>
);

export default StrikethroughSection;
